export const config = {
  BASE_URL: 'http://localhost/api',
};
